import { ChatHistory } from "./chat.types";
import { baseApi } from "@/api/baseApi";

export const chatApi = baseApi.injectEndpoints({
  overrideExisting: false,
  endpoints: builder => ({
    getChatHistory: builder.query<ChatHistory, string>({
      query: id => ({
        url: `/pf-mainweb/question-answer/query/${id}`,
      }),
    }),
    getLastConversationId: builder.query<string, string>({
      query: fseId => ({
        url: `/pf-mainweb/question-answer/get-conversation-id/${fseId}`,
      }),
    }),
    createNewConversation: builder.mutation<string, string>({
      query: fseId => ({
        url: `/pf-mainweb/question-answer/new-conversation-id/${fseId}`,
        method: "POST",
      }),
    }),
    warmUpQaWorkers: builder.mutation<void, void>({
      query: () => ({
        url: "/pf-mainweb/question-answer/warmup",
        method: "POST",
      }),
    }),
  }),
});

export const {
  useGetChatHistoryQuery,
  useGetLastConversationIdQuery,
  useCreateNewConversationMutation,
  useWarmUpQaWorkersMutation,
} = chatApi;
